import { useState } from "react";

import type { TrustRoot } from "../trust/store";

export function TrustStorePanel({
  bundled,
  userRoots,
  onAdd,
  onRemove,
}: {
  bundled: TrustRoot[];
  userRoots: TrustRoot[];
  onAdd: (pem: string) => void;
  onRemove: (subject: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [pemText, setPemText] = useState("");
  const [error, setError] = useState<string | null>(null);

  return (
    <section className="panel trust-panel">
      <h3>
        <button
          type="button"
          className="disclosure"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
        >
          {open ? "▾" : "▸"} Trust store{" "}
          <span className="muted">
            ({bundled.length} bundled, {userRoots.length} yours)
          </span>
        </button>
      </h3>
      {open && (
        <>
          <ul className="root-list">
            {bundled.map((root) => (
              <li key={root.id}>
                <span className="badge badge-note">bundled</span> {root.subject}{" "}
                <span className="muted">until {root.notAfter.slice(0, 10)}</span>
              </li>
            ))}
            {userRoots.map((root) => (
              <li key={root.id}>
                <span className="badge badge-ok">yours</span> {root.subject}{" "}
                <button
                  type="button"
                  className="ghost small"
                  onClick={() => onRemove(root.subject)}
                >
                  remove
                </button>
              </li>
            ))}
          </ul>
          <form
            className="add-root"
            onSubmit={(e) => {
              e.preventDefault();
              setError(null);
              try {
                onAdd(pemText);
                setPemText("");
              } catch (err) {
                setError(err instanceof Error ? err.message : String(err));
              }
            }}
          >
            <textarea
              value={pemText}
              onChange={(e) => setPemText(e.target.value)}
              placeholder="-----BEGIN CERTIFICATE-----  (paste a PEM root to trust; stored only in this browser)"
              rows={3}
            />
            <button type="submit" disabled={!pemText.includes("BEGIN CERTIFICATE")}>
              Add root
            </button>
            {error && <p className="parse-error">{error}</p>}
          </form>
        </>
      )}
    </section>
  );
}
